import Focus from "../../types/enums/focus";
import Pages from "@pages";
import { SeasonParams } from "../../types/interfaces/season";
import { pushRoute } from "../../store/thunks/route.thunk";
import { setFocus } from "../../store/slices/focus.slice";
import { store } from "../../store/store";

function goToSeasonExtended({
  id,
  isRecord,
  seasonId,
  seasonNumber,
}: SeasonParams) {
  store.dispatch(
    setFocus([Focus.RAILS_LIST, parseInt(`${Focus.RAILS_SUB_LIST}0`)])
  );
  store.dispatch(
    pushRoute({
      route: { Page: Pages.SEASON_EXTENDED },
      params: {
        current: { id, isRecord, isSeason: true, seasonId, seasonNumber },
        push: true,
      },
    })
  );
}

export default goToSeasonExtended;
